/**
 * Shopify renders event messages with a little HTML — links to the customer,
 * bold amounts. Shown as text: parsed rather than stripped with a regex, so an
 * entity like `&amp;` reads as `&`, and never injected as markup.
 */
export function plain(html: string | null): string {
  if (!html) return "";
  return (
    new DOMParser()
      .parseFromString(html, "text/html")
      .body.textContent?.trim() ?? ""
  );
}
